import createReducer from 'store/create-reducer';
import {
  SET_CAN_DRAG,
  SET_GO_DOWN,
  SET_CAN_NAVIGATE,
  SET_AUTONAVIGATION,
} from './types';

const INITIAL_STATE = {
  canDrag: true,
  goDown: false,
  canNavigate: true,
  autoNavigation: true, // Indicates if server choose the next step
};

export const setCanDrag = canDrag => (dispatch) => {
  dispatch({ type: SET_CAN_DRAG, canDrag });
};

export const setGoDown = goDown => (dispatch) => {
  dispatch({ type: SET_GO_DOWN, goDown });
};

export const setCanNavigate = canNavigate => (dispatch) => {
  dispatch({ type: SET_CAN_NAVIGATE, canNavigate });
};

export const setAutoNavigation = autoNavigation => (dispatch) => {
  dispatch({ type: SET_AUTONAVIGATION, autoNavigation });
};

const ACTION_HANDLERS = {
  [SET_CAN_DRAG]: (state, { canDrag }) => ({
    ...state,
    canDrag,
  }),
  [SET_GO_DOWN]: (state, { goDown }) => ({
    ...state,
    goDown,
  }),
  [SET_CAN_NAVIGATE]: (state, { canNavigate }) => ({
    ...state,
    canNavigate,
  }),
  [SET_AUTONAVIGATION]: (state, { autoNavigation }) => ({
    ...state,
    autoNavigation,
  }),
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/routes/MainPage/modules/mainPage.js